import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M10 22a3 3 0 01-3-3', key: 'oxdmti' }],
  [
    'path',
    { d: 'M10 22c2.761 0 5-1.79 5-4-4.42 0-4.08-5-8.5-5a4.501 4.501 0 000 9z', key: 'q53vem' },
  ],
  ['path', { d: 'M10 3H8', key: 'mzdi2d' }],
  ['path', { d: 'M12.5 11.5 22 2', key: '1r4cui' }],
  ['path', { d: 'M20 13v4', key: '1ugfop' }],
  ['path', { d: 'M22 15h-4', key: '1es58f' }],
  ['path', { d: 'M4 5v4', key: '13jjxc' }],
  ['path', { d: 'M6 7H2', key: '8zbtv0' }],
  [
    'path',
    {
      d: 'm6.98 13.02 2.665-2.664a1.21 1.21 0 011.71 0l2.29 2.288a1.21 1.21 0 010 1.712l-2.088 2.087',
      key: '1dw0bk',
    },
  ],
  ['path', { d: 'M9 2v2', key: '165o2o' }],
];

/**
 * @component @name MopSparkles
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjJhMyAzIDAgMDEtMy0zIiAvPgogIDxwYXRoIGQ9Ik0xMCAyMmMyLjc2MSAwIDUtMS43OSA1LTQtNC40MiAwLTQuMDgtNS04LjUtNWE0LjUwMSA0LjUwMSAwIDAwMCA5eiIgLz4KICA8cGF0aCBkPSJNMTAgM0g4IiAvPgogIDxwYXRoIGQ9Ik0xMi41IDExLjUgMjIgMiIgLz4KICA8cGF0aCBkPSJNMjAgMTN2NCIgLz4KICA8cGF0aCBkPSJNMjIgMTVoLTQiIC8+CiAgPHBhdGggZD0iTTQgNXY0IiAvPgogIDxwYXRoIGQ9Ik02IDdIMiIgLz4KICA8cGF0aCBkPSJtNi45OCAxMy4wMiAyLjY2NS0yLjY2NGExLjIxIDEuMjEgMCAwMTEuNzEgMGwyLjI5IDIuMjg4YTEuMjEgMS4yMSAwIDAxMCAxLjcxMmwtMi4wODggMi4wODciIC8+CiAgPHBhdGggZD0iTTkgMnYyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/mop-sparkles
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const MopSparkles = createLucideIcon('mop-sparkles', __iconNode);

export default MopSparkles;
